import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { setParticipantView } from '../../../../actions';
import { ParticipantsView } from '../../../../constants';
import './ParticipantsGridShowMore.scss';
const ParticipantsGridShowMore = ({ amount }) => {
    const dispatch = useDispatch();
    const handleClick = useCallback(() => {
        dispatch(setParticipantView(ParticipantsView.List));
    }, []);
    return (<div className="ml-pg-show-more" onClick={handleClick}>
      <FormattedMessage id="video-chat.mobile.other-participants{amount}" values={{
            amount: (<span>+{amount}</span>),
        }}/>
    </div>);
};
export default memo(ParticipantsGridShowMore);
